import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiInputText from './AiInputText'
import ReactGA from 'react-ga';

const mapStateToProps = (state, ownProps) => ({
  value: state[ownProps.attr],
  loading:  state['loading'],
  show: ownProps.show ? 'ai-show':'ai-hide',
  showReview: state.showReview,
  cur_ga_event: state.ga_event
  })

 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoadingDone: (() =>{ 
    //console.log('onLoadingDone')
  //  dispatch(state_update({attr:'showSticky',value:true}) )
    dispatch(state_update({attr:'loading',value:'done'}) )
  }
  ),
  onChange: ( (value) =>{ 
    //console.log('LOCAL onChange text',ownProps.attr,value)
    // var elem1 = document.getElementById("sti");
    // var style = window.getComputedStyle(elem1).getPropertyValue("position");
    // console.log('onChange text', ownProps.switchView,style,"*"); ; 

    if (ownProps.showReview !== true)
      dispatch(state_update({attr:'showReview',value:true}));
    dispatch(state_update({attr:ownProps.attr,value:value}) )
  }
  ),
  onBlur: ( () =>{ 
    dispatch(state_update({attr:'showSticky',value:true}  ))
    //console.log('onBlur text')
  }
  ),
  onFocus:( (state) => { 
    dispatch(state_update({attr:'showSticky',value:false}  ))
   // console.log('event engraving',state)
        
    //console.log('onFocus text',ownProps.options_all.replace('e','E'))
    if (state !== 'Engraving')
    ReactGA.event({
      category: 'Engraving',
      action:ownProps.options_all.replace('e','[E]') 
  });
    dispatch(state_update({attr:'active_view',value:ownProps.switchView}  ))
    dispatch(state_update({attr:'ga_event',value:'Engraving'}))
      
    
  
})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiInputText)


// WEBPACK FOOTER //
// ./src/layout/AiInputTextWrap.js